// extracted by mini-css-extract-plugin
export default {"wrapper":"logo-and-favicon_wrapper__zZBuG"};